import React, { FC } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';

import {
  ClientFollowMappingStatus,
  CreateClientFollowMappingInput,
  useCreateClientFollowMappingMutation,
} from 'api';
import { useNotify } from 'hooks';
import { OnboardingSchema } from 'features/admin/validations';
import { useCreateClientFollowMapping } from 'features/admin/updaters';

import Title from './Title';

type Values = CreateClientFollowMappingInput;
type Helpers = FormikHelpers<CreateClientFollowMappingInput>;

const EMPTY_MAPPING: CreateClientFollowMappingInput = {
  title: '',
  all_users: false,
  mapping_status: ClientFollowMappingStatus.Disabled,
};

const Custom: FC = () => {
  const notify = useNotify();

  const mutationOptions = useCreateClientFollowMapping();
  const { mutateAsync, isLoading } = useCreateClientFollowMappingMutation({
    onSuccess: createNotify,
    ...mutationOptions,
  });

  async function handleCreate(values: Values, helpers: Helpers) {
    await mutateAsync({ data: values });
    helpers.resetForm();
  }

  function createNotify() {
    notify.info({ i18n: { i18nKey: 'admin:onboardingCreate' } });
  }

  return (
    <Formik
      initialValues={EMPTY_MAPPING}
      onSubmit={handleCreate}
      validationSchema={OnboardingSchema}
      render={() => (
        <Form>
          <Title working={isLoading} activeIcon={false} i18nKey="common:add" />
        </Form>
      )}
    />
  );
};

export default Custom;
